import { createStyles, makeStyles } from '@material-ui/core';
import { colorVariables } from '../../../../../styles/colorVariables';
import card from '../../../../../assets/images/bg/card.png';
import { Sizes } from '../../../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    title: {
      marginRight: 20,
    },
    card: {
      borderRadius: 20,
      border: '1px solid rgba(141, 148, 170, 0.3)',
      backgroundColor: '#F5F7FC',
      marginTop: 20,
      backgroundImage: `url(${card})`,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'top 10px right 10px',
      backgroundSize: '46px auto',
      color: colorVariables.navy,
      [theme.breakpoints.down(Sizes.mobile)]: {
        backgroundPosition: 'bottom 10px right 10px',
      },
    },
    cardFeatureTitle: {
      fontSize: 24,
      fontWeight: 700,
      color: colorVariables.navy,
      marginBottom: 20,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 20,
      },
    },
    defaultChip: {
      fontSize: 11,
      fontWeight: 700,
      backgroundColor: '#fff',
      border: `1px solid ${colorVariables.steelGrey}`,
    },
    setDefaultText: {
      fontSize: 14,
      fontWeight: 600,
      color: colorVariables.blue,
      cursor: 'pointer',
    },
    removeCard: {
      marginTop: 20,
      fontSize: 14,
      fontWeight: 600,
      color: colorVariables.red80,
      cursor: 'pointer',
    },
    expiredCardText: {
      textAlign: 'center',
      fontSize: 14,
      fontWeight: 400,
      color: colorVariables.red80,
      marginBottom: 20,
    }
  }),
);
